import Reveal from "@/components/feature/Reveal";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { tagCloud } from "@/mocks/gossip";

const groups = [
  { icon: "ri-bookmark-3-line", label: "话题#", count: "12" },
  { icon: "ri-user-voice-line", label: "人物#", count: "6" },
  { icon: "ri-emotion-happy-line", label: "梗#", count: "9" },
];

export default function TagSection() {
  return (
    <section id="tags" className="w-full bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          index="06"
          title="话题标签分区"
          subtitle="按标签归档，方便你顺着一个关键词把相关内容一次性看完。标签会随热议动态增减。"
        />

        <div className="mt-9 grid grid-cols-1 gap-6 md:mt-12 lg:grid-cols-[300px_1fr]">
          <div className="flex flex-col gap-3">
            {groups.map((g) => (
              <div
                key={g.label}
                className="flex items-center justify-between rounded-lg border border-background-200 bg-background-100 p-4"
              >
                <span className="flex items-center gap-3">
                  <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-100 text-accent-800">
                    <i className={`${g.icon} text-lg`} />
                  </span>
                  <span className="text-sm font-semibold text-foreground-800">{g.label}</span>
                </span>
                <span className="text-sm font-bold text-secondary-600">{g.count}</span>
              </div>
            ))}
          </div>

          <Reveal delay={80}>
            <div className="flex flex-wrap gap-2.5 rounded-lg border border-background-200 bg-background-100 p-5 md:p-6">
              {tagCloud.map((tag) => (
                <a
                  key={tag}
                  href="#hot"
                  className="cursor-pointer rounded-full border border-background-200 bg-background-50 px-4 py-2 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-600 md:text-sm"
                >
                  # {tag}
                </a>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}